module.exports = __webpack_public_path__ + "static/img/logo_dark.0693fd8e.svg";